export default __webpack_public_path__ + "static/media/Shardeum.21f56a88.svg";